const SET_UPDATE_SERVICE = (state, payload) => {
    state.update_service = {};
    state.update_service = payload;
}
const CLEAR_UPDATE_SERVICE = (state) => {
    state.update_service = {};
}

const CLEAR_STATES = (state) => {
    state.update_service = {};
}

export {
    SET_UPDATE_SERVICE,
    CLEAR_UPDATE_SERVICE,
    CLEAR_STATES
}
